import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'

const resource = 'images'
const verb = 'post'

export default class OspreyImagesTagsApply extends BaseAction {
    constructor(dataKey) {
        const id = '60bac4d5-17cd-482f-bd0e-ee16f0d425b0'
        const path = `/${resource}`
        super(resource, verb, path, id, dataKey)
        this.noCache = true
    }

    applyTagToImage(params) {
        const { imageId, tagIdList } = params

        this.path = `/${resource}/${imageId}/tags`

        this.params = {
            tagIdList
        }

        return fetchContentIfNeeded(this)
    }
}



// WEBPACK FOOTER //
// src/actions/osprey-api/images/images-tags-apply.js